import { render } from "./PaymentConfirmation.vue?vue&type=template&id=10b036e6&scoped=true&lang=pug"
import script from "./PaymentConfirmation.vue?vue&type=script&lang=ts"
export * from "./PaymentConfirmation.vue?vue&type=script&lang=ts"

import "./PaymentConfirmation.vue?vue&type=style&index=0&id=10b036e6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-10b036e6"

export default script